import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faInstagram, faLinkedinIn, faYoutube, faTwitter } from '@fortawesome/free-brands-svg-icons'
import {
  faPhone,
  faEnvelope,
  faBars,
  faTimes,
  faCheckCircle,
  faCircle,
  faPerson,
  faAddressCard,
  faUserTie,
  faRemove,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import { faClock } from '@fortawesome/free-regular-svg-icons'

export const setupFontAwesome = () => {
  library.add(
    faCheckCircle,
    faCircle,
    faFacebookF,
    faInstagram,
    faLinkedinIn,
    faYoutube,
    faTwitter,
    faPhone,
    faEnvelope,
    faPerson,
    faUserTie,
    faBars,
    faTimes,
    faClock,
    faRemove,
    faPlus,
    faTrash,
  )
}
